import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`

    .material-box-content > .btn-close {
        z-index: 9999 !important;
    }

`;

export default GlobalStyle;
